export default {
  'Hot Showcase': 'Heat map management',
  'Add Hotspot': 'Add hotspot',
  'Scene Image': 'Scene picture',
  'Hotspot Amount': 'Number of hotspots',
  'Binding Product': 'Related exhibits',
  'Hotspot Created Date': 'Date',
  'On Stage': 'Has recommended',
  'Not On Stage': 'Not recommended',
  'Expand': 'Unfold',
  'Collapes': 'pack up',
  'Set hotspot and combine products': 'Set up hot spots and associate exhibits',
  'Hotspot Upload Image': 'upload image',
  'Combine products': 'Related exhibits',
  'Combine products description': 'Associated exhibits are the exhibits uploaded by you to participate in the online exhibition. If there is no exhibit, please go to the edit exhibit page',
  'Hotspot Upload Tips': 'Note: The size is not less than 1000*560 pixels, supports png and jpg formats, and does not exceed 2Mb. You can upload at most one scene picture',
  'Previous Step': 'Last step',
  'Next Step': 'Next step',
  'Set hotspots and go to product detail.': 'Set hot spots to jump exhibits',
  'Set hotspots': 'Set hot spots ',
  'Hotspot tips2': 'Note: Click anywhere on the picture to add a hotspot, drag to change the position of the hotspot, add at least 1 or at most 10',
  'You can only add the hotspot up to 10': 'You can add up to 10 hotspots',
  'Please enter product name for searching': 'Please enter the name of the exhibit to search',
  'Please select a product': 'Please select exhibits',
  'Hotspot position': 'Hot spot Location.',
  'Hotspot': 'Hot spot',
  'Update combined product': 'Update related exhibits',
  'Are you sure you want to delete this hotspot?': 'Are you sure to delete this heat map?',
  'Hosspot Image': 'Hot spot picture'
}